module.exports = __webpack_public_path__ + "img/a56421b.jpg";